import vipService from '@api/vipConfig'

// 查询积分商城banner
export const scoreBanner = (data) => {
  return vipService.request({
    url: `/score/banner`,
    method: 'post',
    data: data
  })
}
// 分页查询积分商城列表
export const scoreList = (data) => {
  return vipService.request({
    url: `/score/goods/list`,
    method: 'post',
    data: data
  })
}
// 查询商品详情
export const scoreGoodsDetail = (params) => {
  return vipService.request({
    url: `/score/goods/detail`,
    method: 'post',
    params: params
  })
}

// 积分兑换商品
export const scoreExchange = (params) => {
  return vipService.request({
    url: `/score/exchange`,
    method: 'post',
    params: params
  })
}

// 分页获取订单列表
export const orderList = (data) => {
  return vipService.request({
    url: `/score/get/order`,
    method: 'post',
    data: data
  })
}

// 退款
export const scoreRefund = (params) => {
  return vipService.request({
    url: `/score/refund`,
    method: 'post',
    params: params
  })
}

// 获取积分使用记录
export const useRecord = (data) => {
  return vipService.request({
    url: `/score/use/record`,
    method: 'post',
    data: data
  })
}
// 分页获取获得积分记录
export const getRecord = (data) => {
  return vipService.request({
    url: `/score/get/record`,
    method: 'post',
    data: data
  })
}

// 获取积分
export const getNo = (data) => {
  return vipService.request({
    url: `/score/getNo`,
    method: 'post',
    data: data
  })
}

// 查看是否是第一次打电话
export const onceCallCoins = (data) => {
  return vipService.request({
    url: `/coin/onceCallCoins`,
    method: 'post',
    data: data
  })
}
// 花费邀工币打电话
export const callByCoin = (data) => {
  return vipService.request({
    url: `/coin/v4.0/callByCoin`,
    method: 'post',
    data: data
  })
}
// 花费邀工币发消息
export const getImByCoin = (data) => {
  return vipService.request({
    url: `/coin/getImByCoin`,
    method: 'post',
    data: data
  })
}

// 打电话反馈
export const callBack = (data) => {
  return vipService.request({
    url: `/call/back`,
    method: 'post',
    data: data
  })
}

// 获取电话反馈内容
export const callBackContent = (data) => {
  return vipService.request({
    url: `/call/back/content`,
    method: 'post',
    data: data
  })
}
